import {
  WorksheetImagesAndRemarksSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import { PageSection } from '../../../Layout';
import ids from '../../QestIds';
import { ResultsSection } from '../Shared';
import { LiquidLimitMethodAPageSection, PlasticLimitSection, PreparationSection } from './Sections';

const qestIds = [ids.atterbergLimit.ASTM_D_4318.methodA_Rev2017];

let AtterbergLimitWorksheet: WorksheetRootComponent = () => {
  return (
    <>
      <PageSection heading="Preparation">
        <PreparationSection />
      </PageSection>
      <LiquidLimitMethodAPageSection />
      <PlasticLimitSection />
      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <ResultsSection />
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

AtterbergLimitWorksheet.qestIds = qestIds;

export default AtterbergLimitWorksheet;
